import React, { useState } from 'react';
import { Row, Col, Input, Button, Form } from 'antd';

const { TextArea } = Input;

const TextAreaType = ({ question, onEdit, onChange }) => {
  const [textInput, setTextInput] = useState();
  const [form] = Form.useForm();

  const handleTextInput = () => {
    onEdit(question.questionId, form.getFieldValue('option'));
    setTextInput(form.getFieldValue('option'));
  };

  const onFinish = values => {
    form.resetFields();
    onChange(question.testId, question.groupId, question.questionId, values.option);
  };

  return (
    <Row justify="center">
      <Form
        initialValues={{ option: question.selectedAnswer }}
        onFinish={onFinish}
        form={form}
        style={{ width: '100%' }}
      >
        <Col md={24} className="options-wrapper p-30 mt-40 mb-80">
          <Row justify="center">
            <Col md={24}>
              <h2 className="text-center mt-10 mb-50" dangerouslySetInnerHTML={{ __html: question.questionTitle && question.questionTitle }} />
            </Col>
            <Col md={24}>
              <Form.Item
                name="option"
                className="mb-0"
              >
                <TextArea
                  placeholder="Ingrese su respuesta aquí"
                  style={{ width: '100%', height: 150, fontSize: '20px' }}
                  onChange={handleTextInput}
                />
              </Form.Item>
            </Col>
          </Row>
        </Col>
        <Col md={24} className="mb-40">
          {
            question && !question.isChecking &&
            <Row justify="end">
              <Col md={5}>
                <Button
                  disabled={!textInput || textInput === ""}
                  className={(!textInput || textInput === "") && 'button-disabled'}
                  type="primary"
                  size="large"
                  htmlType="submit"
                  block
                >
                  Confirmar cambio
                </Button>
              </Col>
            </Row>
          }
        </Col>
      </Form>
    </Row>
  );
};

export default TextAreaType;